import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useOutletContext } from "react-router-dom";
import { workspaceFolderSelectValidation } from "utils/validations";

import { getWorkspaceConfig } from "../../../store/workspaceConfig/api";
import { Close, CloseModal, Plus } from "../../icons";
import styles from "./style.module.css";

const SendToWorkSpace = (props) => {
  const { openSendToWorkspaceModal, setOpenSendToWorkspaceModal, handleSubmit } = props;
  const { workspaces } = useOutletContext();
  const [workspaceFoldersData, setWorkspaceFoldersData] = useState([]);

  const initialValues = {
    folders: [
      {
        selectedFolderId: "",
        selectedWorkspaceId: "",
      },
    ],
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!workspaces) return;
      const workspaceData = await Promise.all(
        workspaces.map(async (workspace) => {
          const { data } = await getWorkspaceConfig(workspace.workspaceId);
          return { ...workspace, folder_name: data?.folder_name || [] };
        }),
      );
      setWorkspaceFoldersData(workspaceData);
    };

    fetchData();
  }, [workspaces]);

  const closeModal = () => {
    setOpenSendToWorkspaceModal(false);
  };

  const Folders = (props) => {
    const { values, index } = props;
    const selectedWorkspace = workspaceFoldersData.find(
      (workspace) => workspace.workspaceId === values.folders[index].selectedWorkspaceId,
    );
    if (selectedWorkspace) {
      return selectedWorkspace.folder_name.map((folder) => {
        return (
          <option key={folder._id} value={folder._id}>
            {folder.name}
          </option>
        );
      });
    }
  };

  return (
    <Modal
      isOpen={openSendToWorkspaceModal}
      onRequestClose={closeModal}
      shouldCloseOnOverlayClick={false}
      contentLabel="Filter Modal"
      portalClassName="react-modal"
      overlayClassName="modal"
      className="modal-dialog react-modal-dialog-sm modal-dialog-centered"
    >
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={workspaceFolderSelectValidation}
        render={({ values }) => (
          <div className="modal-content">
            <Form>
              <div className="react-modal-header">
                <h5 className="react-modal-title">Send to workspacess</h5>
                <button type="button" className="btn btn__default" onClick={closeModal}>
                  <CloseModal />
                </button>
              </div>
              <div className="react-modal-body">
                <FieldArray
                  name="folders"
                  render={(arrayHelpers) => (
                    <div>
                      {values.folders.map((item, index) => (
                        <div key={index}>
                          <div className={styles.worspaceFolderRow}>
                            <div className={styles.selectFieldContainer}>
                              <label className="form-label">Select workspace</label>
                              <Field
                                name={`folders.${index}.selectedWorkspaceId`}
                                as="select"
                                className={`${styles.customSelect} form-control`}
                              >
                                <option value="">Select</option>
                                {workspaceFoldersData.map((workspace, i) => {
                                  return (
                                    <option
                                      key={i}
                                      value={workspace.workspaceId}
                                      disabled={
                                        !!values.folders.find(
                                          (folder) => folder.selectedWorkspaceId === workspace.workspaceId,
                                        )
                                      }
                                    >
                                      {workspace.name}
                                    </option>
                                  );
                                })}
                              </Field>
                              <ErrorMessage
                                name={`folders.${index}.selectedWorkspaceId`}
                                component="div"
                                className={styles.errorMessage}
                              />
                            </div>
                            <div className={styles.selectFieldContainer}>
                              <label className="form-label">Select workspace folder</label>
                              <Field
                                name={`folders.${index}.selectedFolderId`}
                                as="select"
                                className={`${styles.customSelect} form-control`}
                              >
                                <option value="">Select</option>
                                <Folders values={values} index={index} />
                              </Field>
                              <ErrorMessage
                                name={`folders.${index}.selectedFolderId`}
                                component="div"
                                className={styles.errorMessage}
                              />
                            </div>
                            {values.folders.length > 1 && (
                              <div className={styles.btnBlock}>
                                <button
                                  type="button"
                                  className="btn btn-white"
                                  onClick={() => arrayHelpers.remove(index)}
                                >
                                  <Close />
                                </button>
                              </div>
                            )}
                            {index === values.folders.length - 1 && (
                              <div className={styles.btnBlock}>
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={() =>
                                    arrayHelpers.insert(index + 1, {
                                      selectedFolderId: "",
                                      selectedWorkspaceId: "",
                                    })
                                  }
                                >
                                  <Plus />
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                />
              </div>
              <div className="react-modal-footer">
                <button type="button" className="btn btn-white" onClick={closeModal}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  Send
                </button>
              </div>
            </Form>
          </div>
        )}
      />
    </Modal>
  );
};

export default SendToWorkSpace;
